<template>
  <div class="open-inbox" v-loading="loading">
    <header class="header-container">
      <div class="letters-number">
        <span>发件箱</span>
        <span
          >(共<span class="total">{{ rowCount }}</span
          >封)</span
        >
      </div>
      <div class="operation-btn">
        <div class="left">
          <span class="common-btn" @click="doRemove">删除</span>
          <span class="common-btn" @click="deleteEmails">彻底删除</span>
          <span class="select-btn">
            <el-select v-model="markType" placeholder="标记为..." @change="onChange">
              <el-option v-for="item in markAs" :key="item.value" :label="item.label" :value="item.value"> </el-option>
            </el-select>
          </span>
          <!-- <span class="select-btn">
          <el-select v-model="moveType" placeholder="移动到..." @change="moveTo">
            <el-option v-for="item in moveOptions" :key="item.value" :label="item.label" :value="item.value">
            </el-option>
          </el-select>
        </span> -->
          <span class="select-btn">
            <el-select v-model="emailStatus" @change="statusChange">
              <el-option v-for="item in statusOptions" :key="item.value" :label="item.label" :value="item.value"> </el-option>
            </el-select>
          </span>
        </div>
        <div class="right">
          <span>{{ pageNo }}/{{ totalPage }}页</span>
          <span @click="pagination('start')">首页</span>
          <span @click="pagination('prev')" v-if="pageNo > 1">上一页</span>
          <span @click="pagination('next')" v-if="pageNo < totalPage">下一页</span>
          <span @click="pagination('end')">末页</span>
        </div>
      </div>
      <el-form :inline="true">
        <el-form-item label="发件人">
          <el-input v-model="searchData.smFrom" size="mini" class="w180" clearable> </el-input>
        </el-form-item>
        <el-form-item>
          <el-button size="mini" @click="selectUser" class="mainBtnColor">选择</el-button>
        </el-form-item>
        <el-form-item  label="主题">
          <el-input size="mini" v-model="searchData.smSubject" placeholder="" class="w180"> </el-input>
        </el-form-item>
        <el-form-item  label="日期">
          <el-date-picker size="mini" v-model="searchData.startDate" placeholder="" class="w180"> </el-date-picker>
          -
          <el-date-picker size="mini" v-model="searchData.endDate" placeholder="" class="w180"> </el-date-picker>
        </el-form-item>
        <el-form-item>
          <el-button size="mini" @click="search" class="mainBtnColor">查询</el-button>
          <el-button size="mini" @click="reset">重置</el-button>
        </el-form-item>
      </el-form>
    </header>
    <section class="section-container">
      <el-table
        ref="multipleTable"
        :header-cell-style="{
          background: '#F9F9F9',
          color: '#5A6779',
          textAlign: 'center',
        }"
        :cell-style="{ textAlign: 'center' }"
        :data="tableData"
        border
        @selection-change="handleSelectionChange"
        style="width: 100%"
      >
        <el-table-column type="selection" width="55"> </el-table-column>
        <el-table-column label="发件人">
          <template slot="header">
            <div class="sender-header-box">
              <img src="@/assets/images/oa_mail_sender.png" alt="" />
              <span> 发件人 </span>
            </div>
          </template>
          <template slot-scope="scope">
            <div class="sender-box" @click="onRowClick(scope.row)">
              <img src="../../assets/images/oa_mail_read.png" alt="" v-if="scope.row.read" />
              <img src="../../assets/images/oa_mail_unread.png" alt="" v-else />
              {{ scope.row.emailBody.from }}
            </div>
          </template>
        </el-table-column>
        <el-table-column label="主题">
          <template slot-scope="scope">
            {{ scope.row.emailBody.subject }}
          </template>
        </el-table-column>
        <el-table-column label="接收日期">
          <template slot-scope="scope">
            {{ scope.row.emailBody.sendDate | formDate }}
          </template>
        </el-table-column>
        <el-table-column label="附件大小">
          <template slot="header">
            <div class="extra">
              <img src="@/assets/images/oa_mail_link.png" />
              <span>附件大小</span>
            </div>
          </template>
          <template slot-scope="scope">
            <div v-if="scope.row.emailBody.multipart" class="extra">
              <img src="@/assets/images/oa_mail_link.png" alt="" />
              <span class="download" @click="download(scope.row)">下载</span>
            </div>
          </template>
        </el-table-column>
      </el-table>
    </section>
    <footer class="footer-container">
      <div class="footer-box">
        <span class="select">选择:&nbsp;&nbsp;</span>
        <span class="select-other">
          <span @click="handleSelect('1')">选择所有</span>&nbsp;- <span @click="handleSelect('2')">未读邮件</span>&nbsp;- <span @click="handleSelect('3')">已读邮件</span>&nbsp;-
          <span @click="handleSelect('4')">反选</span>&nbsp;-
          <span @click="handleSelect('5')">不选</span>
        </span>
      </div>
    </footer>

    <!-- userVisible：弹窗可见  closeUserVisiable：关闭弹窗 -->
    <User_Select :userVisible="userVisible" @closeUserVisiable="userVisible = false" @selectedUsersList="selectedUsersList" />
  </div>
</template>

<script>
import User_Select from "../user_select";
export default {
  name: "openInbox",
  components: {
    User_Select,
  },
  created() {
    let id = this.$route.query.id;
    this.folderId = this.$route.query.id;
    let params = {
      folderId: id,
    };
    this.$api.getFolderEmails(params, {
      onSucess: (res) => {
        this.loading = false;
        this.rowCount = res.data.data.rowCount;
        this.tableData = res.data.data.datas;
        this.totalPage = Math.ceil(this.rowCount / 10);
      },
    });
  },
  mounted() {},
  data() {
    return {
      rowCount: 0,
      totalPage: 0,
      folderId: "", // 文件夹id
      emailsId: [], // 选中复选框的值
      loading: true,
      pageNo: 1,
      searchData: {
        smFrom: "",
        smSubject: "",
        startDate: "",
        endDate: "",
      },
      departmentName: "",
      markAs: [
        {
          label: "已读邮件",
          value: 1,
        },
        {
          label: "未读邮件",
          value: 0,
        },
      ],
      markType: "",

      // moveOptions: [{
      //   label: '已发送',
      //   value: true,
      // }, ],
      // moveType: '',

      emailStatus: "0", // 邮件状态
      statusOptions: [
        // 邮件状态选项
        {
          value: "0",
          label: "所有",
        },
        {
          value: "1",
          label: "未读",
        },
        {
          value: "2",
          label: "已读",
        },
      ],
      tableData: [],
      userVisible: false, // 用户选择弹窗
    };
  },

  methods: {
    /**
     * 标记为已读未读
     */
    onChange(ev) {
      if (this.emailsId.length <= 0) {
        this.$message({
          message: "未选中任何邮件",
          type: "warning",
        });
        this.markType = "";
      } else {
        this.$api.markEmail(this.folderId, this.markType, this.emailsId, {
          onSucess: (res) => {
            if (res.data.errcode == 0) {
              this.markType = "";
              let params = {
                folderId: this.folderId,
                pageNo: 1,
                linesPerPage: 10,
              };
              // 重新发送请求
              this.getEmailsData(params);
            }
          },
        });
      }
    },

    /**
     * 移动邮件
     */
    /* moveTo() {
      if (this.emailsId.length <= 0) {
        this.$message({
          message: '未选中任何邮件',
          type: 'warning'
        });
        this.moveType = '';
      } else {
        this.$message.warning('待完善')
      }
    }, */

    /**
     * 筛选已读未读邮件
     */
    statusChange() {
      let params = {
        folderId: this.folderId,
        pageNo: 1,
        linesPerPage: 10,
      };
      if (this.emailStatus == 0) {
        this.getEmailsData(params);
      } else if (this.emailStatus == 1) {
        params.unread = "false";
        this.getEmailsData(params);
      } else if (this.emailStatus == 2) {
        params.unread = "true";
        this.getEmailsData(params);
      }
    },

    /**
     * 重置
     */
    reset() {
      this.searchData = {
        smFrom: "",
        smSubject: "",
        startDate: "",
        endDate: "",
      };
      this.departmentName = "";
    },

    /**
     * 查询
     */
    search() {
      let params = {
        folderId: this.folderId,
        pageNo: 1,
        linesPerPage: 10,
      };
      let startDate = "";
      let endDate = "";

      if (this.searchData.startDate) {
        startDate = this.formDate(this.searchData.startDate);
      }
      if (this.searchData.endDate) {
        endDate = this.formDate(this.searchData.endDate);
      }
      params.startDate = startDate;
      params.endDate = endDate;

      if (this.searchData.smFrom) {
        params.smFrom = this.searchData.smFrom;
      }
      if (this.searchData.smSubject) {
        params.smSubject = this.searchData.smSubject;
      }
      this.getEmailsData(params);
    },

    /**
     * 邮件选择状态
     */
    handleSelect(type) {
      let tableData = this.tableData;
      if (type === "1") {
        tableData.forEach((row) => {
          this.$refs.multipleTable.toggleRowSelection(row);
        });
      } else if (type === "2") {
        tableData.forEach((row) => {
          if (!row.read) {
            this.$refs.multipleTable.toggleRowSelection(row);
          }
        });
      } else if (type === "3") {
        tableData.forEach((row) => {
          if (row.read) {
            this.$refs.multipleTable.toggleRowSelection(row);
          }
        });
      } else if (type === "4") {
        tableData.forEach((row) => {
          this.$refs.multipleTable.toggleRowSelection(row);
        });
      } else {
        this.$refs.multipleTable.clearSelection();
      }
    },

    /**
     * 页码值的改变
     */
    pagination(pageNum) {
      if (pageNum === "start") {
        this.pageNo = 1;
        let params = {
          folderId: this.folderId,
          pageNo: 1,
          linesPerPage: 10,
        };
        // 重新发送请求
        this.getEmailsData(params);
      } else if (pageNum === "prev") {
        this.pageNo = this.pageNo - 1;
        if (this.pageNo === 1) {
          this.pageNo = 1;
        } else {
          let params = {
            folderId: this.folderId,
            pageNo: this.pageNo,
            linesPerPage: 10,
          };

          // 重新发送请求
          this.getEmailsData(params);
        }
      } else if (pageNum === "next") {
        this.pageNo = this.pageNo + 1;
        if (this.pageNo > this.totalPage) {
          this.pageNo = this.totalPage;
        } else {
          let params = {
            folderId: this.folderId,
            pageNo: this.pageNo,
            linesPerPage: 10,
          };
          // 重新发送请求
          this.getEmailsData(params);
        }
      } else {
        this.pageNo = this.totalPage;
        let params = {
          folderId: this.folderId,
          pageNo: this.totalPage,
          linesPerPage: 10,
        };
        this.getEmailsData(params);
      }
    },

    /**
     * 删除邮件
     */
    doRemove() {
      if (this.emailsId.length === 0) {
        this.$message({
          message: "请至少选择一条数据!",
          type: "warning",
        });
      } else {
        this.$confirm("确定删除？", "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
        })
          .then(() => {
            this.$api.removeEmails(this.folderId, this.emailsId, {
              onSucess: (res) => {
                if (res.data.errcode === 0) {
                  this.$notify({
                    title: "删除成功!",
                    message: "",
                    type: "success",
                  });
                  this.$emit("event");
                }
              },
            });
          })
          .catch(() => {});
      }
    },

    /**
     * 彻底删除邮件
     */
    deleteEmails() {
      if (this.emailsId.length === 0) {
        this.$message({
          message: "请至少选择一条数据!",
          type: "warning",
        });
      } else {
        this.$confirm("确定删除？", "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
        })
          .then(() => {
            this.$api.deleteEmails(this.folderId, this.emailsId, {
              onSucess: (res) => {
                if (res.data.errcode === 0) {
                  this.$notify({
                    title: "删除成功!",
                    message: "",
                    type: "success",
                  });
                  this.$emit("event");
                }
              },
            });
          })
          .catch(() => {});
      }
    },

    /**
     * 选择用户弹窗
     */
    selectUser() {
      this.userVisible = true;
    },

    /**
     * 将值写入输入框
     */
    selectedUsersList(arr) {
      let tempArr = [];
      arr.map((item) => {
        tempArr.push(item.name);
      });
      this.searchData.smFrom = tempArr.join(",");
    },

    /**
     * 复选框的改变
     */
    handleSelectionChange(val) {
      if (val.length > 0) {
        let ids = [];
        val.forEach((item) => {
          ids.push(item.id);
        });
        this.emailsId = ids;
      } else {
        this.emailsId = [];
      }
    },

    /**
     * 格式化时间
     */
    formDate: function(value) {
      let date = new Date(value);
      let year = date.getFullYear();
      let month = date.getMonth() + 1;
      let day = date.getDate();
      // let hour = date.getHours();
      // let minute = date.getMinutes();
      // let second = date.getSeconds();
      month = month >= 10 ? month : "0" + month;
      day = day >= 10 ? day : "0" + day;
      return year + "-" + month + "-" + day;
    },

    /**
     * 数据回显
     */
    onRowClick(row) {
      this.$router.push({
        path: "/inbox",
        query: {
          folderId: this.folderId,
          id: row.id,
        },
      });
    },

    /**
     * 下载附件
     */
    download(row) {
      this.loading = true;
      let that = this;
      this.$api.getEmailDetail(that.folderId, row.id, {
        onSucess: (res) => {
          if (res.data.errcode == 0) {
            // 遍历下载每一个文件
            res.data.data.emailBody.attachments.map((item) => {
              this.loading = true;
              this.$api.downloadFile(that.folderId, row.id, item.fileName, {
                onSucess: (response) => {
                  this.loading = false;
                  this.getOutExcel(res.data.data.emailBody.attachments[0].fileName, response.data);
                },
              });
            });
          }
        },
      });
    },

    /**
     * 二进制数据流转xls
     */
    getOutExcel(fileName, res) {
      let blob = new Blob([res], { type: "application/x-xls" });
      if (window.navigator.msSaveOrOpenBlob) {
        //兼容 IE & EDGE
        navigator.msSaveBlob(blob, fileName);
      } else {
        var link = document.createElement("a");
        // 兼容不同浏览器的URL对象
        const url = window.URL || window.webkitURL || window.moxURL;
        // 创建下载链接
        link.href = url.createObjectURL(blob);
        //命名下载名称
        link.download = fileName;
        //点击触发下载
        link.click();
        //下载完成进行释放
        url.revokeObjectURL(link.href);
      }
    },

    /**
     * 获取邮件列表数据
     */
    getEmailsData(params) {
      this.loading = true;
      this.$api.getFolderEmails(params, {
        onSucess: (res) => {
          this.loading = false;
          this.tableData = res.data.data.datas;
        },
      });
    },
  },
  filters: {
    formDate: function(value) {
      let date = new Date(value);
      let year = date.getFullYear();
      let month = date.getMonth() + 1;
      let day = date.getDate();
      let hour = date.getHours();
      let minute = date.getMinutes();
      let second = date.getSeconds();
      return year + "-" + month + "-" + day + " " + hour + ":" + minute + ":" + second;
    },
  },
};
</script>
